export default __webpack_public_path__ + "static/media/TradingPartners.267c6357.svg";